"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoPlayerContext = void 0;
exports.VideoPlayerProvider = VideoPlayerProvider;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var VideoPlayerContext = exports.VideoPlayerContext = /*#__PURE__*/(0, _react.createContext)({
  playersInitialized: {},
  setPlayersInitialized: function setPlayersInitialized() {}
});
function VideoPlayerProvider(_ref) {
  var children = _ref.children;
  var _useState = (0, _react.useState)({}),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    playersInitialized = _useState2[0],
    setPlayersInitialized = _useState2[1];
  var playerContextValue = (0, _react.useMemo)(function () {
    return {
      playersInitialized: playersInitialized,
      setPlayersInitialized: setPlayersInitialized
    };
  }, [playersInitialized, setPlayersInitialized]);
  return /*#__PURE__*/_react["default"].createElement(VideoPlayerContext.Provider, {
    value: playerContextValue
  }, children);
}